<div
	*ngIf="management$ | async as management; else noManagement"
	class="flex flex-col gap-1"
>
	<div class="flex gap-2 justify-start items-center">
		<label>{{ label }}</label>
		<app-icon
			*ngIf="showAiIcon$ | async"
			[icon]="AI_GENERATED_ICON.icon"
			[classes]="AI_GENERATED_ICON.classes"
			[matTooltip]="AI_GENERATED_ICON.tooltip"
		/>
	</div>
	<app-firm-card
		[name]="management?.name"
		[phone]="management?.phoneNumber"
		[fax]="management?.faxNumber"
		[address]="condoManagementAddressString$ | async"
		[email]="management?.email"
		member="Management Company"
		memberType="Business"
		(dropdown)="condoManagementDropdownEvent($event, management)"
	/>
</div>
<ng-template #noManagement>
	<app-search-management-company-input
		[label]="label"
		(onSelect)="onSelectCondoCorporationManagement($event)"
		(onCreate)="onCreateCondoManagement($event)"
	/>
</ng-template>
